var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.popinModal.id,
        "aria-labelledby": _vm.popinModal.label,
        "show-close-button": _vm.popinModal.showCloseButton,
      },
    },
    [
      _c("h4", { attrs: { id: "modalTitle" } }, [
        _vm._v("\n        " + _vm._s(_vm.dto.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pt-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.popinSections && _vm.popinSections.length
            ? _c(
                "div",
                { attrs: { id: "modalContent" } },
                _vm._l(_vm.popinSections, function (section, index) {
                  return _c("div", { key: index }, [
                    _c(
                      "div",
                      { staticClass: "alert-container h-100 px-0 mb-0" },
                      [
                        _c("p", { staticClass: "alert" }, [
                          _c("span", {
                            staticClass: "alert-icon",
                            class: [section.icon],
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "ob1-alert-title",
                            domProps: { innerHTML: _vm._s(section.title) },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "alert-content" }, [
                          _c("p", {
                            staticClass: "alert-text",
                            domProps: { innerHTML: _vm._s(section.paragraph) },
                          }),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }